/* cSpell:disable */

type ContactsIconProps = {
  tableSize?: boolean;
  stroked?: boolean;
};

export const ContactsIcon = ({ tableSize, stroked }: ContactsIconProps) => {
  return (
    <>
      {!stroked && (
        <svg
          height={tableSize ? 19 : 32}
          viewBox="0 0 20 20"
          width={tableSize ? 19 : 32}
          xmlns="http://www.w3.org/2000/svg"
        >
          <g data-name="Grupo 7400" id="Grupo_7400" transform="translate(0 0.163)">
            <rect
              data-name="Rectángulo 3174"
              fill="none"
              height={tableSize ? 19 : 32}
              id="Rectángulo_3174"
              transform="translate(0 -0.163)"
              width={tableSize ? 19 : 32}
            />
            <g data-name="Grupo 6604" id="Grupo_6604" transform="translate(0.959 0.837)">
              <g data-name="Grupo 6567" id="Grupo_6567" transform="translate(11.799 13.724)">
                <path
                  d="M-1225.1,99.2a4.6,4.6,0,0,0,.284.663h0C-1224.911,99.673-1225.005,99.389-1225.1,99.2Z"
                  data-name="Trazado 3928"
                  fill="#004dbc"
                  id="Trazado_3928"
                  transform="translate(1225.1 -99.2)"
                />
              </g>
              <g data-name="Grupo 6568" id="Grupo_6568" transform="translate(8.865 10.695)">
                <path
                  d="M-1228.2,96Z"
                  data-name="Trazado 3929"
                  fill="#004dbc"
                  id="Trazado_3929"
                  transform="translate(1228.2 -96)"
                />
              </g>
              <g data-name="Grupo 6569" id="Grupo_6569" transform="translate(9.149 10.6)">
                <path
                  d="M-1227.9,95.9a.348.348,0,0,1,.284.095.348.348,0,0,0-.284-.095Z"
                  data-name="Trazado 3930"
                  fill="#004dbc"
                  id="Trazado_3930"
                  transform="translate(1227.9 -95.9)"
                />
              </g>
              <g data-name="Grupo 6570" id="Grupo_6570" transform="translate(9.811 7.691)">
                <path
                  d="M-1219.155,97.155A7.605,7.605,0,0,0-1221.9,92.9a.6.6,0,0,0-.568,0,4.633,4.633,0,0,1-3.975.663,5.364,5.364,0,0,1-.757,1.23c.095,0,.095.095.189.095a8.157,8.157,0,0,1,3.029,4.448h3.123C-1218.587,99.521-1219.155,97.155-1219.155,97.155Z"
                  data-name="Trazado 3931"
                  fill="#004dbc"
                  id="Trazado_3931"
                  transform="translate(1227.2 -92.825)"
                />
              </g>
              <path
                d="M-1225.3,84.7a3.941,3.941,0,0,0-3.6,2.366,4.717,4.717,0,0,1,2.745,4.259,3.217,3.217,0,0,1-.095.946,2.918,2.918,0,0,0,.947.095,3.838,3.838,0,0,0,3.88-3.88A3.817,3.817,0,0,0-1225.3,84.7Z"
                data-name="Trazado 3932"
                fill="#004dbc"
                id="Trazado_3932"
                transform="translate(1237.103 -84.7)"
              />
              <g data-name="Grupo 6573" id="Grupo_6573" transform="translate(2.24 2.84)">
                <circle
                  cx="3.88"
                  cy="3.88"
                  data-name="Elipse 1742"
                  fill="#004dbc"
                  id="Elipse_1742"
                  r="3.88"
                  transform="translate(0 0)"
                />
              </g>
              <g data-name="Grupo 6574" id="Grupo_6574" transform="translate(0 10.53)">
                <path
                  d="M-1225.389,100.155a7.606,7.606,0,0,0-2.745-4.259.6.6,0,0,0-.568,0,4.847,4.847,0,0,1-5.49,0,.6.6,0,0,0-.568,0,7.326,7.326,0,0,0-2.745,4.259s-.568,2.271,1.7,2.271h8.707C-1224.821,102.426-1225.389,100.155-1225.389,100.155Z"
                  data-name="Trazado 3933"
                  fill="#004dbc"
                  id="Trazado_3933"
                  transform="translate(1237.567 -95.825)"
                />
              </g>
            </g>
          </g>
        </svg>
      )}
      {stroked && (
        <svg
          height={tableSize ? 19 : 32}
          viewBox="0 0 20 20"
          width={tableSize ? 19 : 32}
          xmlns="http://www.w3.org/2000/svg"
        >
          <g data-name="Grupo 7401" id="Grupo_7401" transform="translate(-733 -397)">
            <rect
              data-name="Rectángulo 4100"
              fill="none"
              height={tableSize ? 19 : 32}
              id="Rectángulo_4100"
              transform="translate(733 397)"
              width={tableSize ? 19 : 32}
            />
            <g data-name="Grupo 6604" id="Grupo_6604" transform="translate(-3869.448 20014)">
              <g data-name="Grupo 6567" id="Grupo_6567" transform="translate(4615.431 -19601.58)">
                <g
                  data-name="Trazado 3928"
                  fill="none"
                  id="Trazado_3928"
                  transform="translate(1225.1 -99.2)"
                >
                  <path
                    d="M-1225.1,99.2a4.806,4.806,0,0,0,.3.7h0C-1224.9,99.7-1225,99.4-1225.1,99.2Z"
                    stroke="none"
                  />
                  <path
                    d="M -1225.10009765625 99.20001220703125 C -1225.000732421875 99.39891052246094 -1224.9013671875 99.69725799560547 -1224.801635742188 99.89616394042969 C -1224.9013671875 99.69725799560547 -1225.000732421875 99.49836730957031 -1225.10009765625 99.20001220703125 Z"
                    fill="#004dbc"
                    stroke="none"
                  />
                </g>
              </g>
              <g data-name="Grupo 6568" id="Grupo_6568" transform="translate(4612.349 -19604.76)">
                <path
                  d="M-1228.2,96Z"
                  data-name="Trazado 3929"
                  fill="none"
                  id="Trazado_3929"
                  stroke="#004dbc"
                  strokeWidth="1.5"
                />
              </g>
              <g data-name="Grupo 6569" id="Grupo_6569" transform="translate(4612.647 -19604.859)">
                <g
                  data-name="Trazado 3930"
                  fill="none"
                  id="Trazado_3930"
                  transform="translate(1227.9 -95.9)"
                >
                  <path d="M-1227.9,95.9a.365.365,0,0,1,.3.1.365.365,0,0,0-.3-.1Z" stroke="none" />
                  <path
                    d="M -1227.900024414062 95.90000915527344 C -1227.800537109375 95.90000915527344 -1227.701049804688 95.90000915527344 -1227.601684570312 95.99945068359375 C -1227.701049804688 95.90000915527344 -1227.800537109375 95.90000915527344 -1227.900024414062 95.90000915527344 Z"
                    fill="#004dbc"
                    stroke="none"
                  />
                </g>
              </g>
              <g data-name="Grupo 6570" id="Grupo_6570" transform="translate(4613.343 -19607.918)">
                <g
                  data-name="Trazado 3931"
                  fill="none"
                  id="Trazado_3931"
                  transform="translate(1227.2 -92.825)"
                >
                  <path
                    d="M-1218.747,97.375a7.991,7.991,0,0,0-2.884-4.475.634.634,0,0,0-.6,0,4.868,4.868,0,0,1-4.177.7,5.642,5.642,0,0,1-.8,1.293c.1,0,.1.1.2.1a8.571,8.571,0,0,1,3.182,4.674h3.282C-1218.15,99.861-1218.747,97.375-1218.747,97.375Z"
                    stroke="none"
                  />
                  <path
                    d="M -1220.274291992188 98.17351531982422 C -1220.241088867188 98.17351531982422 -1220.213134765625 98.17226409912109 -1220.189819335938 98.17041778564453 C -1220.173461914062 98.0504150390625 -1220.178588867188 97.86467742919922 -1220.205688476562 97.72538757324219 L -1220.206176757812 97.72644805908203 L -1220.21484375 97.68227386474609 C -1220.235595703125 97.59122467041016 -1220.667846679688 95.75753784179688 -1222.004516601562 94.52025604248047 C -1222.775146484375 94.93640899658203 -1223.60986328125 95.18933868408203 -1224.467895507812 95.26612854003906 C -1223.606567382812 96.279052734375 -1223.063354492188 97.36679077148438 -1222.743774414062 98.16218566894531 L -1220.474365234375 98.16218566894531 L -1220.412109375 98.16736602783203 C -1220.363159179688 98.17144775390625 -1220.31689453125 98.17351531982422 -1220.2744140625 98.17351531982422 L -1220.274291992188 98.17351531982422 M -1220.2744140625 99.67351531982422 C -1220.357543945312 99.67351531982422 -1220.444946289062 99.66983795166016 -1220.536743164062 99.66218566894531 L -1223.818725585938 99.66218566894531 C -1224.017333984375 98.86660003662109 -1224.912719726562 96.38034820556641 -1227.0009765625 94.98805999755859 C -1227.100219726562 94.98805999755859 -1227.100219726562 94.88861083984375 -1227.199829101562 94.88861083984375 C -1226.9013671875 94.49079895019531 -1226.603271484375 94.09299468994141 -1226.404174804688 93.59575653076172 C -1225.012084960938 93.99355316162109 -1223.5205078125 93.79469299316406 -1222.227294921875 92.89959716796875 C -1222.028564453125 92.80015563964844 -1221.829467773438 92.80015563964844 -1221.630737304688 92.89959716796875 C -1219.34326171875 94.49079895019531 -1218.746704101562 97.37483978271484 -1218.746704101562 97.37483978271484 C -1218.746704101562 97.37483978271484 -1218.19482421875 99.67356109619141 -1220.2744140625 99.67351531982422 Z"
                    fill="#004dbc"
                    stroke="none"
                  />
                </g>
              </g>
              <g
                data-name="Trazado 3932"
                fill="none"
                id="Trazado_3932"
                transform="translate(5840.553 -19700.699)"
              >
                <path
                  d="M-1225.121,84.7a4.141,4.141,0,0,0-3.779,2.486,4.957,4.957,0,0,1,2.884,4.475,3.386,3.386,0,0,1-.1.994,3.066,3.066,0,0,0,.995.1,4.033,4.033,0,0,0,4.077-4.077A4.011,4.011,0,0,0-1225.121,84.7Z"
                  stroke="none"
                />
                <path
                  d="M -1225.120971679688 86.20001220703125 C -1225.738891601562 86.20001220703125 -1226.308715820312 86.41324615478516 -1226.768798828125 86.798583984375 C -1225.481689453125 87.90993499755859 -1224.661987304688 89.49098205566406 -1224.533813476562 91.19244384765625 C -1224.057983398438 91.08795166015625 -1223.627197265625 90.85584259033203 -1223.28515625 90.51383209228516 C -1222.806884765625 90.03559875488281 -1222.543579101562 89.38362884521484 -1222.543579101562 88.67800140380859 C -1222.543579101562 87.28847503662109 -1223.675659179688 86.20001220703125 -1225.120971679688 86.20001220703125 M -1225.120971679688 84.70001220703125 C -1222.932983398438 84.70001220703125 -1221.043579101562 86.39066314697266 -1221.043579101562 88.67800140380859 C -1221.043579101562 90.96533966064453 -1222.83349609375 92.75543975830078 -1225.120971679688 92.75543975830078 C -1225.518798828125 92.75543975830078 -1225.817016601562 92.75543975830078 -1226.115478515625 92.65598297119141 C -1226.01611328125 92.35763549804688 -1226.01611328125 91.9598388671875 -1226.01611328125 91.66149139404297 C -1226.01611328125 89.6724853515625 -1227.20947265625 87.98184967041016 -1228.900024414062 87.18624114990234 C -1228.203857421875 85.69450378417969 -1226.8115234375 84.70001220703125 -1225.120971679688 84.70001220703125 Z"
                  fill="#004dbc"
                  stroke="none"
                />
              </g>
              <g data-name="Grupo 6573" id="Grupo_6573" transform="translate(4605.387 -19613.016)">
                <g
                  data-name="Elipse 1742"
                  fill="none"
                  id="Elipse_1742"
                  stroke="#004dbc"
                  strokeWidth="1.5"
                  transform="translate(0 0)"
                >
                  <circle cx="4.077" cy="4.077" r="4.077" stroke="none" />
                  <circle cx="4.077" cy="4.077" fill="none" r="3.327" />
                </g>
              </g>
              <g data-name="Grupo 6574" id="Grupo_6574" transform="translate(4603.034 -19604.938)">
                <g
                  data-name="Trazado 3933"
                  fill="none"
                  id="Trazado_3933"
                  transform="translate(1237.567 -95.825)"
                >
                  <path
                    d="M-1224.771,100.375a7.991,7.991,0,0,0-2.884-4.475.634.634,0,0,0-.6,0,5.094,5.094,0,0,1-5.768,0,.634.634,0,0,0-.6,0,7.7,7.7,0,0,0-2.884,4.475s-.6,2.387,1.79,2.387h9.149C-1224.174,102.762-1224.771,100.375-1224.771,100.375Z"
                    stroke="none"
                  />
                  <path
                    d="M -1226.560913085938 101.2616424560547 C -1226.385864257812 101.2616424560547 -1226.279052734375 101.2388610839844 -1226.229736328125 101.2223510742188 C -1226.197387695312 101.1212615966797 -1226.195068359375 100.8997650146484 -1226.226806640625 100.737922668457 L -1226.228271484375 100.7367324829102 L -1226.238891601562 100.6823501586914 C -1226.259643554688 100.5913772583008 -1226.693237304688 98.75154113769531 -1228.035278320312 97.51410675048828 C -1229.007446289062 98.02651214599609 -1230.079345703125 98.29464721679688 -1231.1728515625 98.29464721679688 C -1232.267822265625 98.29464721679688 -1233.322631835938 98.02623748779297 -1234.261962890625 97.51316833496094 C -1235.56787109375 98.67877960205078 -1236.002075195312 100.5456848144531 -1236.029541015625 100.669303894043 L -1236.028076171875 100.6773452758789 L -1236.04296875 100.7305755615234 C -1236.076171875 100.8929672241211 -1236.074462890625 101.1196899414062 -1236.04150390625 101.2223281860352 C -1235.9921875 101.2388458251953 -1235.88525390625 101.2616424560547 -1235.710205078125 101.2616424560547 L -1226.560913085938 101.2616424560547 M -1226.560913085938 102.7616424560547 L -1235.710205078125 102.7616424560547 C -1238.09716796875 102.7616424560547 -1237.50048828125 100.3748397827148 -1237.50048828125 100.3748397827148 C -1237.50048828125 100.3748397827148 -1236.903686523438 97.39134216308594 -1234.616333007812 95.89959716796875 C -1234.417602539062 95.80015563964844 -1234.218383789062 95.80015563964844 -1234.019653320312 95.89959716796875 C -1232.328979492188 97.09300231933594 -1230.04150390625 97.09300231933594 -1228.25146484375 95.89959716796875 C -1228.052978515625 95.80022430419922 -1227.853881835938 95.80010223388672 -1227.654907226562 95.89959716796875 C -1225.367431640625 97.49077606201172 -1224.770751953125 100.3748397827148 -1224.770751953125 100.3748397827148 C -1224.770751953125 100.3748397827148 -1224.174194335938 102.7616424560547 -1226.560913085938 102.7616424560547 Z"
                    fill="#004dbc"
                    stroke="none"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )}
    </>
  );
};
